import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material';


type TabularProps = {
    children: any,
    rows: string[],
    sx?: any,
    size?: 'small' | 'medium',
    columnAlign?: Array<'left' | 'right' | 'center' | 'inherit'>,
    headerColor?: 'primary' | 'secondary',
}
export default function Tabular({ children, rows, sx, size, columnAlign, headerColor = 'primary' }: TabularProps) {
    const theme=useTheme()
    const dense = size === 'small';
    const headerPalette = headerColor === 'secondary' ? theme.palette.secondary : theme.palette.primary;
    return (
        <TableContainer component={Paper}>
            <Table stickyHeader aria-label="table" size={size} sx={sx}>
                <TableHead sx={{
                    '.MuiTableCell-root':{
                    backgroundColor: headerPalette.main,
                    color: headerPalette.contrastText,
                    border: `1px solid ${headerPalette.main}`,
                    p: dense ? '4px 8px' : '8px',
                    height: dense ? 36 : undefined,
                    fontSize: dense ? '11px' : undefined,
                    lineHeight: dense ? 1.2 : undefined,
                    boxSizing: 'border-box',
                }}}>
                    <TableRow sx={{ height: dense ? 36 : undefined }}>
                        {rows.map((item: string, i:number) =>
                            <TableCell key={`${item}-${i}`} align={columnAlign?.[i] || 'left'}>{item}</TableCell>
                        )}
                    </TableRow>
                </TableHead>
                <TableBody>
                    {children}
                </TableBody>
            </Table>
        </TableContainer>
    );
}